// extracted by mini-css-extract-plugin
module.exports = {"Education":"EducationEN_Education__3d5hK"};